<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6">
      <button type="button" pButton icon="fa fa-plus" (click)="crearPagaduriaCondicion()" *ngIf="verAgregar && !detalle"
        label="{{ 'BTN_AGREGAR' | translate }}"></button>
    </div>
    <div class="col-12 md:col-6 lg:col-6">
      <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
        (input)="dt.filterGlobal($event.target.value, 'contains')" [(ngModel)]="busqueda" (change)="setBusqueda()" />
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carPagaduriasCondiciones" #dt [value]="pagaduriasCondiones"
        selectionMode="single" dataKey="idPagaduriaCondicion" [paginator]="true" [rows]="10"
        paginatorPosition="bottom" [globalFilterFields]="[
          'version',
          'fechaInicioVigenciaMostrar',
          'estado',
          'usuarioAprueba',
          'usuarioConfigura'
        ]">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
              class="text-center">
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="text-center">{{ row.version }}</td>
            <td class="text-center">{{ row.fechaInicioVigenciaMostrar }}</td>
            <td class="text-center" class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorApruebaLibranza" binary="true" disabled="true"></p-checkbox>
            </td>
            <td class="text-center">{{ row.diaPago }}</td>
            <td class="text-center">{{ row.diaCorte }}</td>
            <td class="text-center">{{ row.desfaseAntes }}</td>
            <td class="text-center">{{ row.desfaseDespues }}</td>
            <td pTooltip="{{ row.metodoDescripcion }}" tooltipPosition="top">
              {{ row.metodo }}
            </td>
            <td class="text-center">
              {{ row.auditoriaFecha | date: "dd-MM-yyyy" }}
            </td>
            <td class="text-center">
              {{ row.auditoriaFecha | date: "HH:mm:ss" }}
            </td>
            <td class="text-center">{{ row.usuarioConfigura }}</td>
            <td class="text-center">{{ row.usuarioAprueba }}</td>
            <td class="text-center">{{ row.estado }}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                  title="{{ 'BTN_VISUALIZAR' | translate }}" pButton
                  (click)="crearPagaduriaCondicion(row, true)"></button>
                <button type="button" class="p-button btn" icon="fa fa-pencil" data-toggle="tooltip"
                  title="{{ 'BTN_EDITAR' | translate }}"
                  *ngIf="verAprobacionCondicion && row.codigoEstado === codigoEstadoFuncionalidad.PENDIENTE" pButton
                  (click)="crearPagaduriaCondicion(row, true, true)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td class="text-center" [attr.colspan]="columns.length">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
